import { CurrencyType } from "@/constants/currencyTypeConst"

const defaultChip: Record<string, [number, string][]> = {
  chipSetting1: [
    [10, "10"],
    [30, "30"],
    [50, "50"],
    [100, "100"],
    [200, "200"],
    [300, "300"],
    [500, "500"],
    [1000, "1K"],
    [3000, "3K"],
    [5000, "5K"],
    [10000, "10K"],
    [50000, "50K"]
  ],
  chipSetting2: [
    [50, "50"],
    [100, "100"],
    [200, "200"],
    [300, "300"],
    [500, "500"],
    [1000, "1K"],
    [3000, "3K"],
    [5000, "5K"],
    [10000, "10K"],
    [50000, "50K"],
    [100000, "100K"],
    [200000, "200K"]
  ],
  chipSetting3: [
    [100, "100"],
    [200, "200"],
    [300, "300"],
    [500, "500"],
    [1000, "1K"],
    [3000, "3K"],
    [5000, "5K"],
    [10000, "10K"],
    [50000, "50K"],
    [100000, "100K"],
    [200000, "200K"],
    [300000, "300K"]
  ],
  chipSetting4: [
    [500, "500"],
    [1000, "1K"],
    [3000, "3K"],
    [5000, "5K"],
    [10000, "10K"],
    [50000, "50K"],
    [100000, "100K"],
    [200000, "200K"],
    [300000, "300K"],
    [500000, "500K"],
    [1000000, "1000K"],
    [5000000, "5000K"]
  ],
  chipSetting5: [
    [1000, "1K"],
    [3000, "3K"],
    [5000, "5K"],
    [10000, "10K"],
    [50000, "50K"],
    [100000, "100K"],
    [200000, "200K"],
    [300000, "300K"],
    [500000, "500K"],
    [1000000, "1000K"],
    [5000000, "5000K"],
    [10000000, "10000K"]
  ],
  chipSetting6: [
    [10000, "10K"],
    [15000, "15K"],
    [20000, "20K"],
    [25000, "25K"],
    [50000, "50K"],
    [100000, "100K"],
    [150000, "150K"],
    [200000, "200K"],
    [250000, "250K"],
    [300000, "300K"],
    [500000, "500K"],
    [1000000, "1000K"]
  ],
  chipSetting7: [
    [15000, "15K"],
    [20000, "20K"],
    [25000, "25K"],
    [50000, "50K"],
    [100000, "100K"],
    [150000, "150K"],
    [200000, "200K"],
    [250000, "250K"],
    [300000, "300K"],
    [500000, "500K"],
    [1000000, "1000K"],
    [5000000, "5000K"]
  ],
  chipSetting8: [
    [1000, "1000"],
    [10000, "10K"],
    [30000, "30K"],
    [50000, "50K"],
    [100000, "100K"],
    [150000, "150K"],
    [300000, "300K"],
    [500000, "500K"]
  ],
  chipSetting9: [
    [5500, "5500"],
    [10000, "10K"],
    [15000, "15K"],
    [20000, "20K"],
    [25000, "25K"],
    [30000, "30K"],
    [50000, "50K"],
    [100000, "100K"]
  ],
  chipSetting10: [
    [1000, "1k"],
    [3000, "3K"],
    [5000, "5K"],
    [10000, "10K"],
    [15000, "15K"],
    [20000, "20K"],
    [25000, "25K"],
    [50000, "50K"]
  ],
  chipSetting11: [
    [40, "40"],
    [200, "200"],
    [300, "300"],
    [500, "500"],
    [1000, "1K"],
    [3000, "3K"],
    [5000, "5K"],
    [10000, "10K"]
  ],
  chipSetting12: [
    [4, "4"],
    [30, "30"],
    [50, "50"],
    [100, "100"],
    [200, "200"],
    [300, "300"],
    [500, "500"],
    [1000, "1K"],
    [3000, "3K"],
    [5000, "5K"],
    [10000, "10K"],
    [50000, "50K"]
  ],
  default: [
    [1, "1"],
    [2, "2"],
    [3, "3"],
    [4, "4"],
    [5, "5"],
    [6, "6"],
    [7, "7"],
    [8, "8"],
    [9, "9"],
    [10, "19"],
    [11, "11"],
    [12, "12"]
  ]
}

const symbol: Record<CurrencyType, string> = {
  [CurrencyType.HKD]: "$",
  [CurrencyType.INR]: "", // &#8377;
  [CurrencyType.EUR]: "&#8364;",
  [CurrencyType.USD]: " ",
  [CurrencyType.THB]: "&#3647;",
  [CurrencyType.AED]: "&#1583;.&#1573;",
  [CurrencyType.PHP]: "&#8369;",
  [CurrencyType.GBP]: "&#163;",
  [CurrencyType.RMB]: "&#165;",
  [CurrencyType.PTS]: " ",
  [CurrencyType.KRW]: "&#8361;",
  [CurrencyType.IDR]: "Rp",
  [CurrencyType.PTU]: " ",
  [CurrencyType.PTE]: " ",
  [CurrencyType.PTG]: " ",
  [CurrencyType.PTH]: " ",
  [CurrencyType.PTI]: " ",
  [CurrencyType.PUI]: " ",
  [CurrencyType.PTR]: " ",
  [CurrencyType.PTA]: " ",
  [CurrencyType.PTM]: " ",
  [CurrencyType.P]: " ",
  [CurrencyType.PTD]: " ",
  [CurrencyType.IR]: " ",
  [CurrencyType.PTAD]: " ",
  [CurrencyType.PBU]: " ",
  [CurrencyType.VND]: " ",
  [CurrencyType.EHK]: " ",
  [CurrencyType.PKR]: " ",
  [CurrencyType.PKU]: " ",
  [CurrencyType.PR]: " ",
  [CurrencyType.PIN]: " ",
  [CurrencyType.BDT]: " ",
  [CurrencyType.PSU]: " ",
  [CurrencyType.PNU]: " ",
  [CurrencyType.PAU]: " ",
  [CurrencyType.PZU]: " ",
  [CurrencyType.PHK]: " ",
  [CurrencyType.NPR]: " ",
  [CurrencyType.PSD]: " ",
  [CurrencyType.USDT]: " ",
  [CurrencyType.MYR]: " ",
  [CurrencyType.BRL]: " ",
  [CurrencyType.INP]: " ",
  [CurrencyType.ZAR]: " ",
  [CurrencyType.PTP]: " ",
  [CurrencyType.NHK]: " ",
  [CurrencyType.LKR]: " ",
  [CurrencyType.CAD]: " "
}

const currencyToCoinTypeMap: Record<CurrencyType, [number, string][]> = {
  [CurrencyType.HKD]: defaultChip.chipSetting3,
  [CurrencyType.INR]: defaultChip.chipSetting5,
  [CurrencyType.EUR]: defaultChip.chipSetting1,
  [CurrencyType.USD]: defaultChip.chipSetting1,
  [CurrencyType.THB]: defaultChip.chipSetting4,
  [CurrencyType.AED]: defaultChip.chipSetting2,
  [CurrencyType.PHP]: defaultChip.chipSetting4,
  [CurrencyType.GBP]: defaultChip.chipSetting1,
  [CurrencyType.RMB]: defaultChip.chipSetting3,
  [CurrencyType.PTS]: defaultChip.chipSetting2,
  [CurrencyType.KRW]: defaultChip.chipSetting6,
  [CurrencyType.IDR]: defaultChip.chipSetting7,
  [CurrencyType.PTU]: defaultChip.chipSetting1,
  [CurrencyType.PTE]: defaultChip.chipSetting12,
  [CurrencyType.PTG]: defaultChip.chipSetting1,
  [CurrencyType.PTH]: defaultChip.chipSetting1,
  [CurrencyType.PTI]: defaultChip.chipSetting2,
  [CurrencyType.PUI]: defaultChip.chipSetting1,
  [CurrencyType.PTR]: defaultChip.chipSetting3,
  [CurrencyType.PTA]: defaultChip.chipSetting2,
  [CurrencyType.PTM]: defaultChip.chipSetting2,
  [CurrencyType.P]: defaultChip.chipSetting1,
  [CurrencyType.PTD]: defaultChip.chipSetting2,
  [CurrencyType.IR]: defaultChip.chipSetting8,
  [CurrencyType.PTAD]: defaultChip.chipSetting2,
  [CurrencyType.PBU]: defaultChip.chipSetting1,
  [CurrencyType.VND]: defaultChip.chipSetting4,
  [CurrencyType.EHK]: defaultChip.chipSetting3,
  [CurrencyType.PKR]: defaultChip.chipSetting9,
  [CurrencyType.PKU]: defaultChip.chipSetting2,
  [CurrencyType.PR]: defaultChip.chipSetting10,
  [CurrencyType.PIN]: defaultChip.chipSetting8,
  [CurrencyType.BDT]: defaultChip.chipSetting4,
  [CurrencyType.PSU]: defaultChip.chipSetting2,
  [CurrencyType.PNU]: defaultChip.chipSetting2,
  [CurrencyType.PAU]: defaultChip.chipSetting2,
  [CurrencyType.PZU]: defaultChip.chipSetting2,
  [CurrencyType.PHK]: defaultChip.chipSetting2,
  [CurrencyType.NPR]: defaultChip.chipSetting8,
  [CurrencyType.PSD]: defaultChip.chipSetting2,
  [CurrencyType.USDT]: defaultChip.chipSetting12,
  [CurrencyType.MYR]: defaultChip.chipSetting2,
  [CurrencyType.BRL]: defaultChip.chipSetting2,
  [CurrencyType.INP]: defaultChip.chipSetting8,
  [CurrencyType.ZAR]: defaultChip.chipSetting3,
  [CurrencyType.PTP]: defaultChip.chipSetting9,
  [CurrencyType.NHK]: defaultChip.chipSetting8,
  [CurrencyType.LKR]: defaultChip.chipSetting9,
  [CurrencyType.CAD]: defaultChip.chipSetting1
}

export const getCurrencyDefaultOfQuickStakes = (currencyId: CurrencyType) => {
  return currencyToCoinTypeMap[currencyId] || defaultChip.default
}

export const getCurrencyDefaultOfSymbol = (currencyId: CurrencyType) => {
  const str = symbol[currencyId] || " "
  const parser = new DOMParser()

  return parser.parseFromString(str, "text/html").documentElement.textContent
}

export default getCurrencyDefaultOfQuickStakes
